import { Observable } from "rxjs"

import { ObservableFromFetch } from "../ObservableFromFetch"

export interface PoolSelectionCancel {
  PoolSelectionID: number
}

export interface PoolSelectionRerun {
  PoolSelectionID: number
  RequiredDrug: number
  RequiredAlcohol: number
  AlternateDrug: number
  AlternateAlcohol: number
  ExtraDrug: number
  ExtraAlcohol: number
  AccountID: number
}

export function PoolSelectionCancelObservable(poolSelection: PoolSelectionCancel): Observable<string> {
  const params: string = JSON.stringify({
    PoolSelectionID: poolSelection.PoolSelectionID,
  })
  return ObservableFromFetch<string>("WorkforceRandomTest/PoolSelectionCancel", params)
}

export function PoolSelectionRerunObservable(poolSelection: PoolSelectionRerun): Observable<string> {
  const params: string = JSON.stringify({
    PoolSelectionID: poolSelection.PoolSelectionID,
    RequiredDrug: poolSelection.RequiredDrug,
    RequiredAlcohol: poolSelection.RequiredAlcohol,
    AlternateDrug: poolSelection.AlternateDrug,
    AlternateAlcohol: poolSelection.AlternateAlcohol,
    ExtraDrug: poolSelection.ExtraDrug,
    ExtraAlcohol: poolSelection.ExtraAlcohol,
  })
  return ObservableFromFetch<string>("WorkforceRandomTest/PoolSelectionRerun", params)
}
